import {useQuery} from '@tanstack/react-query'
import {getGoalSupporters} from '../services/goal.http'
import {QUERY_KEYS} from './keys'

export const useFetchSupportersV3 = (goalId: string) => {
    return useQuery({
        queryKey: [QUERY_KEYS.supportersList, goalId],
        queryFn: () => getGoalSupporters({goalId}),
        enabled: !!goalId
    })
}
